// extracted by mini-css-extract-plugin
export default {"headerTitle":"style_headerTitle__Kd2Le"};